import { InlineDangerMessage } from "components/InlineDangerMessage";
import { useTranslation } from "react-i18next";

import { formatCrremMissingFields } from "../lib/formatMissingFields";

type CrremPathwayIncompleteNoticeProps = {
  missing: string[];
};

export const CrremPathwayIncompleteNotice = ({ missing }: CrremPathwayIncompleteNoticeProps) => {
  const { t } = useTranslation();
  if (missing.length === 0) return null;
  return (
    <InlineDangerMessage
      message={t("BuildingProfile.crremPathway.incomplete", { fields: formatCrremMissingFields(missing) })}
    />
  );
};
